import type { Ingredient, IngredientSection } from '../types'

export const image = (slug: string) => `/images/recipes/${slug}.png`

export const ingredient = (
  id: string,
  name: string,
  display: string,
  options: Partial<Ingredient> = {},
): Ingredient => ({
  id,
  name,
  display,
  shoppingKey: options.shoppingKey ?? name.toLocaleLowerCase('fr-FR'),
  ...options,
})

export const scaled = (
  id: string,
  name: string,
  amount: number,
  unit: string,
  options: Partial<Ingredient> = {},
): Ingredient => ingredient(id, name, '', { amount, unit, scalable: true, ...options })

export const section = (title: string, items: Ingredient[]): IngredientSection => ({ title, items })

export const peopleScaler = (base: number, max: number = 10) => ({
  kind: 'linear' as const,
  label: 'Nombre de personnes',
  min: base,
  max,
  step: 2,
  base,
  resultLabel: (value: number) => `${value} personne${value > 1 ? 's' : ''}`,
})
